import { render, staticRenderFns } from "./ModalBusinessUsePercentageNew.vue?vue&type=template&id=3b150ff2&"
import script from "./ModalBusinessUsePercentageNew.vue?vue&type=script&lang=js&"
export * from "./ModalBusinessUsePercentageNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports